import { type ComponentProps } from 'react';

import { Button } from './Button';

export const PrimaryButton = (props: Omit<ComponentProps<typeof Button>, 'variant'>) => (
  <Button {...props} variant="primary" />
);
